function resetAllQuickButtonsMessages(sizeSelector) {
  const sizeSelectorList = sizeSelector.querySelector('.quick-size-selector__list');
  const buttons = sizeSelectorList.querySelectorAll('.quick-size-selector__option');
  buttons.forEach((button) => {
    button.querySelector('.quick-size-selector__no-stock').classList.add('hidden');
    button.querySelector('.quick-size-selector__error').classList.add('hidden');
  });
}

function handleQuickAddToCart(event) {
  const data = event.detail;
  if (data.status) {
    const sizeSelectorList = document.querySelector('.quick-size-selector__list');
    const selectedVariant = sizeSelectorList?.dataset.selectedVariant;
    const sizeButton = sizeSelectorList.querySelector(`.quick-size-selector__option[data-variant="${selectedVariant}"]`);
    if (sizeButton && data.status === 422) {
      sizeButton.querySelector('.quick-size-selector__no-stock').classList.remove('hidden');
    } else if (sizeButton) {
      sizeButton.querySelector('.quick-size-selector__error').classList.remove('hidden');
    }
  } else {
    event.target.closest('.quick-size-selector').classList.remove('quick-size-selector--active');
  }
}

function handleQuickSizeClick(event) {
  resetAllQuickButtonsMessages(event.target.closest('.quick-size-selector'));
  const form = event.target.closest('product-form');
  const buyButton = form?.querySelector('button.quick-add__submit');
  if (!buyButton) {
    return;
  }
  const button = event.target;
  const selectedVariant = event.target.closest('.quick-size-selector__option').dataset.variant;
  const sizeSelectorList = button.closest('.quick-size-selector__list');
  const formSizeInput = form.querySelector('.product-variant-id');
  const lastSelectedVariant = sizeSelectorList.dataset.selectedVariant;
  sizeSelectorList.dataset.selectedVariant = selectedVariant;
  formSizeInput.value = selectedVariant;
  if (lastSelectedVariant === selectedVariant) {
    document.body.addEventListener('product:addToCart', handleQuickAddToCart);
    buyButton.click();
  }
}

function addQuickSizeSelectorEvents(element) {
  const sizeSelectorWrapperList = element.querySelectorAll('.quick-size-selector-wrapper');
  sizeSelectorWrapperList.forEach((sizeSelectorWrapper) => {

    const selectSizeButton = sizeSelectorWrapper.querySelector('.quick-size-selector-button');
    const sizeSelectorClose = sizeSelectorWrapper.querySelector('.quick-size-selector__close');
    const sizeSelector = sizeSelectorWrapper.querySelector('.quick-size-selector');
    if (selectSizeButton && sizeSelector) {
      selectSizeButton.addEventListener('click', () => {
        sizeSelector.classList.toggle('quick-size-selector--active');
      });
    }
    if (sizeSelectorClose && sizeSelector) {
      sizeSelectorClose.addEventListener('click', () => {
        sizeSelector.classList.toggle('quick-size-selector--active');
      });
    }
    if (sizeSelector) {
      delegateEvent('click', '.quick-size-selector__option', handleQuickSizeClick);
    }
  });
}

addQuickSizeSelectorEvents(document);
